import styled, { css } from 'styled-components';

export const StyledInput = styled.input`
  ${({ removeArrows }) =>
    removeArrows &&
    css`
      ::-webkit-inner-spin-button,
      ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      -moz-appearance: textfield;
    `}
`;
